import { Link } from "react-router-dom";
import { Linkedin, Twitter, Youtube, Instagram, Heart, ArrowUpRight } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const EBG_LOGO = "https://customer-assets-gfyr7b9c.emergentagent.net/job_pitch-netflix-1/artifacts/xg253r21_EBG%20Logo.png";

const cols = [
  { title: "Platform", items: [["Pitches", "/pitches"], ["Live Webinars", "/live"], ["Events", "/events"], ["Rankings", "/rankings"], ["How It Works", "/#how-it-works"]] },
  { title: "For Investors", items: [["Browse Pitches", "/pitches"], ["Top Startups", "/rankings"], ["Investment Opportunities", "/pitches"], ["Create Account", "/pricing"]] },
  { title: "For Founders", items: [["Raise Capital", "/pricing"], ["How It Works", "/#how-it-works"], ["Success Stories", "/"], ["Founder Resources", "/"]] },
  { title: "Company", items: [["About Us", "/"], ["Blog", "/"], ["Careers", "/"], ["Contact Us", "/"]] },
];

export const Footer = () => (
  <footer className="bg-[#080808] border-t border-white/5 relative z-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-2 md:grid-cols-6 gap-10">
      <div className="col-span-2">
        <img src={LOGO_URL} alt="EBN" className="h-12 w-auto mb-4" />
        <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
          The ultimate marketplace for startup investments. Discover, connect, and invest in the next big thing.
        </p>
        <div className="flex gap-3 mt-5">
          {[Linkedin, Twitter, Youtube, Instagram].map((Icon, i) => (
            <a key={i} href="#social" aria-label="social" className="p-2 rounded-md border border-white/10 text-zinc-500 hover:text-[#F5B301] hover:border-[#F5B301]/40 transition-colors">
              <Icon size={15} />
            </a>
          ))}
        </div>
        <a
          href="https://theebg.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ebg-badge"
          className="mt-6 inline-flex items-center gap-4 rounded-2xl border border-white/15 bg-[#0b0a08] px-5 py-4 hover:border-[#F5B301]/50 transition-colors"
        >
          <img src={EBG_LOGO} alt="EBG" className="h-9 w-auto" />
          <span className="text-left leading-snug">
            <span className="block text-sm text-white">An <span className="text-[#F5B301] font-semibold">EBG</span> Group Company</span>
            <span className="text-[11px] text-zinc-500 flex items-center gap-1">theebg.com <ArrowUpRight size={10} /></span>
          </span>
        </a>
      </div>
      {cols.map((c) => (
        <div key={c.title}>
          <h4 className="text-sm font-semibold text-white mb-4">{c.title}</h4>
          <ul className="space-y-2.5">
            {c.items.map(([label, to]) => (
              <li key={label}>
                <Link to={to} className="text-sm text-zinc-500 hover:text-[#F5B301] transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/5 py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-600">
        <span>© 2026 Elite Business Network (EBN). All rights reserved.</span>
        <span data-testid="reachvel-credit">
          Design and Development by{" "}
          <a href="https://www.reachvel.com" target="_blank" rel="noopener noreferrer" className="text-[#F5B301] font-semibold hover:underline">Reachvel</a>
        </span>
        <span className="flex items-center gap-1.5">Made with <Heart size={12} className="text-[#F5B301] fill-[#F5B301]" /> for entrepreneurs, by entrepreneurs.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
